import React, { createContext, useContext, useState, useEffect } from "react";
import { registerLoadingHandler } from "../api/FetchAuditList";
import Loader from "../components/common/Loader";

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Register this component to handle loading states from APIs
    const unregister = registerLoadingHandler((isLoading, loadingMessage) => {
      setLoading(isLoading);
      if (loadingMessage) setMessage(loadingMessage);
    });

    return unregister;
  }, []);

  return (
    <LoaderContext.Provider value={{ setLoading, setMessage }}>
      {loading && <Loader message={message} />}
      {children}
    </LoaderContext.Provider>
  );
};
